import {
	Checkbox,
	FormControlLabel,
	IconButton,
	TableCell,
	TableRow,
	Tooltip,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useState } from "react";
import { AddUpdateUserDialog } from "./add-update-user-dialog";
import { IDropDownFields } from "../../../utility/interfaces";
type ComponentProps = {
	data: any;
	getAllRecords: any;
	addUpdateApiUrl: string;
	deleteApiUrl: string;
	title: string;
};
export function UsersRecordRow(props: ComponentProps) {
	const { data, getAllRecords, title, addUpdateApiUrl, deleteApiUrl } = props;
	const [isUpdateRecordOpen, setIsUpdateRecordOpen] = useState(false);
	const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

	return (
		<>
			<TableRow key={data.id}>
				<TableCell>{data.name}</TableCell>
				<TableCell>{data.email}</TableCell>
				<TableCell>{data.mobile}</TableCell>
				<TableCell>{data.roleName}</TableCell>
				<TableCell>{data.parentName}</TableCell>
				<TableCell>
					<FormControlLabel
						control={<Checkbox checked={data.isActive ? true : false} />}
						label={data.isActive ? "Active" : "Deactivate"}
					/>
				</TableCell>
				<TableCell className="action-col" align="center">
					<div className="button-wrapper">
						<Tooltip title="Edit User">
							<IconButton
								onClick={() => setIsUpdateRecordOpen(true)}
								aria-label="Edit"
								color="primary"
							>
								<Edit />
							</IconButton>
						</Tooltip>
						{/* <IconButton
							aria-label="Delete"
							onClick={() => setIsDeleteDialogOpen(true)}
							color="primary"
						>
							<Delete />
						</IconButton> */}
					</div>
				</TableCell>
			</TableRow>
			{/* Update record  */}
			<AddUpdateUserDialog
				dialogOpen={isUpdateRecordOpen}
				handleOnClickClose={() => setIsUpdateRecordOpen(false)}
				recordId={data.userId}
				getAllRecords={getAllRecords}
			/>
			{/* <DeleteCommonRecord
				getAllRecords={getAllRecords}
				apiPath={`${deleteApiUrl}/${data.id}`}
				dialogOpen={isDeleteDialogOpen}
				handleOnClickClose={() => setIsDeleteDialogOpen(false)}
			/> */}
		</>
	);
}
